import { TaskDto } from "../../features/tasks/types";

export const demoTasks: TaskDto[] = [];
